module.exports = __webpack_public_path__ + "static/media/commandeJour.95a800ca.png";